const locales = {
  en: 'English',
  es: 'Español',
  pt: 'Português'
};

type Locale = keyof typeof locales;

const defaultFallbackLocale = 'en' as Locale;

const sourceLocale = defaultFallbackLocale;

const cookieName = 'i18nLang';

const prefixDefault = false;

const noPrefix = false;

const i18nConfig = {
  locales: Object.keys(locales),
  defaultLocale: defaultFallbackLocale,
  localeCookie: cookieName,
  prefixDefault, // To also include your default locale in the path, set the prefixDefault config option to true.
  noPrefix // To hide all locales from the path, set the noPrefix config option to true.
};

const getPathnameWithoutLocale = (pathname: string) => {
  let path = pathname;
  const localeKeys = Object.keys(locales);

  // Remove leading slash if it exists
  if (path.startsWith('/')) {
    path = path.substring(1);
  }

  // Extract the first part of the path
  const pathSegments = path.split('/');
  const firstSegment = pathSegments[0];

  if (firstSegment && localeKeys.includes(firstSegment)) {
    return `/${pathSegments.slice(1).join('/')}`;
  }

  return `/${pathSegments.join('/')}`;
};

const getAlternateRefs = (pathname: string) =>
  Object.keys(locales).reduce(
    (acc, locale) => {
      const pathnameWithoutLocale = getPathnameWithoutLocale(pathname);

      let urlLocale = `/${locale}`;

      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      if (!prefixDefault && locale === defaultFallbackLocale) {
        urlLocale = '';
      }

      acc[locale] = `${urlLocale}${pathnameWithoutLocale}`;

      return acc;
    },
    {} as { [key: string]: string }
  );

export type { Locale };
export {
  locales,
  sourceLocale,
  defaultFallbackLocale,
  cookieName,
  i18nConfig,
  prefixDefault,
  noPrefix,
  getAlternateRefs,
  getPathnameWithoutLocale
};
